export default __webpack_public_path__ + "static/media/SWT0520.34I-18760_-14568_0.53e5ea1e.jpg";